import { actions } from "../actions/facilities.action";

const INITIAL_STATE = {
  allFacilities: [],
  clinicFacilities: [],
  mobileFacilities: [],
  isFetchingFacilities: true,
};

const reducer = (state = INITIAL_STATE, data) => {
  switch (data.type) {
    case actions.SET_FACILITIES:
      const mobileFacilities = data?.data?.filter(facility => (facility?.operationTypeIds?.includes(1)
        || facility?.operationTypeId === 1) && facility?.isActive
      )
      const clinicFacilities = data?.data?.filter(facility => (facility?.operationTypeIds?.includes(2)
        || facility?.operationTypeId === 2) && facility?.isActive
      )
      const telehealthFacilities = data?.data?.filter(facility => (facility?.operationTypeIds?.includes(3)
        || facility?.operationTypeId === 3) && facility?.isActive
      )

      return {
        ...state, allFacilities: data.data,
        clinicFacilities: clinicFacilities ?? [],
        mobileFacilities: mobileFacilities ?? [],
        isFetchingFacilities: false
      };
    case actions.SET_CLINIC_FACILITIES:
      return { ...state, clinicFacilities: data.data };
    case actions.SET_MOBILE_FACILITIES:
      return { ...state, mobileFacilities: data.data };
    case actions.SET_FETCHING_FACILITIES:
      return { ...state, isFetchingFacilities: data.isFetchingFacilities };
    case "RESET":
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
